import { Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import { RefreshService } from '@sgm-frontend/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(
    private injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  getRToken(): string | null {
    if (!this.isBrowser()) return null;
    return localStorage.getItem('refreshToken');
  }
  getUserState(): string | null {
    if (!this.isBrowser()) return null;
    return localStorage.getItem('is_guest');
  }
  getRGToken(): string | null {
    if (!this.isBrowser()) return null;
    return localStorage.getItem('GrefreshToken');
  }

  getToken(): string | null {
    if (!this.isBrowser()) return null;
    if (localStorage.getItem('accessToken')) {
      return localStorage.getItem('accessToken');
    } else {
      return localStorage.getItem('GaccessToken');
    }

  }
  getAdminToken(): string | null {
    if (!this.isBrowser()) return null;
    if (localStorage.getItem('accessToken')) {
      return localStorage.getItem('accessToken');
    } else {
      return '';
    }

  }
  setDiviceToken(dToken: string): void {
    if (!this.isBrowser()) return;
    localStorage.setItem('deviceToken', dToken);
  }
  getDiviceToken(): string | null {
    if (!this.isBrowser()) return null;
    return localStorage.getItem('deviceToken');
  }
  setToken(token: any): void {
    if (!this.isBrowser()) return;
    localStorage.setItem('accessToken', token.accessToken);
    localStorage.setItem('refreshToken', token.refreshToken);
  }
  setLanguage(lan: string): void {
    if (!this.isBrowser()) return;
    localStorage.setItem('app_language', lan);
  }
  setUserInfo(user:any):void {
    if (!this.isBrowser()) return;
    let userDetail:any = {
      full_name:user?user?.full_name:'',
      email:user?user?.email:'',
      username:user?user?.username:''
    }
    localStorage.setItem('user', JSON.stringify(userDetail));
  }
  getUserInfo():any |null {
    if (!this.isBrowser()) return null;
    return localStorage.getItem('user');
  }
  setGuestToken(token: any): void {
    if (!this.isBrowser()) return;
    localStorage.setItem('GaccessToken', token.accessToken);
    localStorage.setItem('GrefreshToken', token.refreshToken);
  }
  setGuestAccessToken(Token: string) {
    if (!this.isBrowser()) return;
    localStorage.setItem('GaccessToken', Token);
  }
  setAccessToken(token: any): void {
    if (!this.isBrowser()) return;
    localStorage.setItem('accessToken', token.accessToken);
  }
  setGustUser(is_guest: string): void {
    if (!this.isBrowser()) return;
    localStorage.setItem('is_guest', is_guest);
  }
  checkIsGuest() {
    if (!this.isBrowser()) return false;
    if (localStorage.getItem('is_guest') === 'true') {
      return true;
    }
    return false;
  }
  clearTokens() {
    if (!this.isBrowser()) return;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    // FIX: also clear guest tokens — without this, getToken() falls back to
    // a possibly-stale GaccessToken, which can itself be orphaned and
    // re-trigger the same 404 "User not found" error on the next request,
    // widening the race window and causing multiple independent
    // getGuestTokens() calls instead of one shared recovery.
    localStorage.removeItem('GaccessToken');
    localStorage.removeItem('GrefreshToken');
    localStorage.removeItem('user');
    localStorage.setItem('is_guest', "true");
  }
    clearAdminTokens() {
    if (!this.isBrowser()) return;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  }
}